
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { createSavedCampaignInDb } from './services/db/savedCampaignService';

export const useTermsAcceptance = (
  setShowPayment?: (show: boolean) => void
) => {
  const [showTerms, setShowTerms] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const insertCampaignAsAdmin = async (campaignData: any) => {
    try {
      console.log('Inserting campaign data to saved_campaigns table');
      
      // Ensure campaignData has all required fields
      if (!campaignData.campaign_id) {
        console.error('Missing campaign_id in campaign data');
        toast({
          title: "Campaign Insert Failed",
          description: "Missing required campaign data. Please try again.",
          variant: "destructive",
        });
        return false;
      }
      
      // Use the established service for reliable insertion
      // This now includes duplicate checking
      const { data, error } = await createSavedCampaignInDb({
        ...campaignData,
        status: campaignData.status || 'pending'
      });
      
      if (error) {
        console.error('Error inserting campaign as admin:', error);
        toast({
          title: "Campaign Insert Failed",
          description: "Failed to save campaign data. Please try again.",
          variant: "destructive",
        });
        return false;
      }
      
      console.log('Admin campaign insert result:', data);
      toast({
        title: "Campaign Saved",
        description: "Successfully saved campaign data.",
        variant: "default",
      });
      return true;
    } catch (err) {
      console.error('Error calling admin-insert-campaign function:', err);
      toast({
        title: "Campaign Insert Error",
        description: "An unexpected error occurred while saving campaign data.",
        variant: "destructive",
      });
      return false;
    }
  };

  const handleAcceptTerms = async () => {
    try {
      console.log("Terms acceptance: handling accept terms action");
      
      // Simply close terms dialog and open payment screen
      // No campaign creation at this stage
      setShowTerms(false);
      
      console.log("Terms acceptance: setting showPayment to true");
      if (setShowPayment) {
        setShowPayment(true);
      } else {
        console.warn("Terms acceptance: setShowPayment function not provided");
      }
    } catch (error) {
      console.error("Error in handleAcceptTerms:", error);
      toast({
        title: "Error",
        description: "There was a problem proceeding to payment. Please try again.",
        variant: "destructive"
      });
    }
  };

  return {
    showTerms,
    setShowTerms,
    isSubmitting,
    handleAcceptTerms,
    insertCampaignAsAdmin
  };
};
